import { render, staticRenderFns } from "./Step5Review.vue?vue&type=template&id=dee4a5e0&scoped=true&"
import script from "./Step5Review.vue?vue&type=script&lang=js&"
export * from "./Step5Review.vue?vue&type=script&lang=js&"
import style0 from "./Step5Review.vue?vue&type=style&index=0&id=dee4a5e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee4a5e0",
  null
  
)

export default component.exports